import _ from 'underscore'
import Zepto from 'zepto-webpack'

import Events from '@/configuration/Events'
const docLinks = require('./../../configuration/sources/JsClientDocLinks.yml')

/* I might need to take a look to: src/app/src/Registry.js line 142
 * on how to use this class in KryptonPanelWarning.vue to Filter shit out
 */

export default class CustomFilters {
  constructor($locator) {
    this.$locator = $locator
    this.$bus = $locator.$bus
  }

  replaceBaseAddress(errorCode) {
    const $locator = this.$locator
    const state = $locator.$store.state
    const baseAddress = state.baseAddress
    const urlList = _.pairs(docLinks['js_client_doc_links'])
    let hostURL = ''
    urlList.forEach(key => {
      let originURL = key[1]['doc_home'].split('/')[2]
      if (baseAddress.indexOf(originURL) !== -1) {
        hostURL = key[1].errors
      } else {
        hostURL = docLinks['js_client_doc_links'].default.errors
      }
    })
    let text = hostURL.replace('{%ERROR CODE%}', errorCode)
    return text
  }
}
